{
  "nav": {
    "pricing": "Prezzi",
    "contact": "Contatti",
    "menu": "Menu",
    "login": "Accedi",
    "features": "Funzionalità",
    "brandHomeAria": "Done-it — home",
    "market": {
      "belgium": "Belgio",
      "international": "Tutto il mondo"
    }
  },
  "footer": {
    "tagline": "Done-it — Rilevamento orari, semplice.",
    "terms": "Termini",
    "privacy": "Privacy",
    "contact": "Contatti"
  },
  "help": "Hai bisogno di aiuto?",
  "continue": "Continua",
  "back": "Indietro",
  "change": "Modifica",
  "retry": "Riprova",
  "errors": {
    "unexpected": "Errore imprevisto"
  },
  "step": {
    "of": "Passo {{n}} di {{total}}"
  },
  "funnel": {
    "title": "Abbonamento · Done-it"
  }
}
